<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="imprimirEtiquetasLoteModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Imprimir Etiquetas</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    type="select"
                                    label="Selecione o Tipo de Etiqueta..."
                                    optionsMode="aql"
                                    service="tipo_etiqueta_amostras.index"
                                    optionsData2="id_tipo_etiqueta_amostra"
                                    optionsName="tipo_etiqueta_amostras.index.gerar"
                                    :optionsParm="{ ativos: true, geracao: true }"
                                    required
                                    :validate="validate"
                                    v-model="tipo_etq" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Servidor de Impressão"
                                    placeholder="Não informado..."
                                    required
                                    :validate="validate"
                                    v-model="servidor_impressao" />
                            </div>
                        </div>

                        <template v-if="lista_filtrada && lista_filtrada.length">

                            <az-input
                                sizing="sm"
                                icon="fa fa-search"
                                class="mt-3"
                                placeholder="Informar Atendimento..."
                                v-model="pesquisa"
                                @onEnter="selecionar_atendimento()" />

                            <table class="table table-sm table-hover small mt-3 cabecalho-fixo-modal">
                                <thead>
                                    <tr>
                                        <th>
                                            <a href="#" @click.prevent="toggle_selecionados()">
                                                <i class="fa-solid fa-square"></i>
                                            </a>
                                        </th>
                                        <table-th title="Paciente" v-model="ordem" sortby="atendimento_procedimento.atendimento.paciente.st_nome">
                                            <span class="badge badge-secondary ml-2">{{ selecionados.length }}</span>
                                        </table-th>
                                        <table-th title="#" v-model="ordem" sortby="atendimento_procedimento.id_atendimento"></table-th>
                                        <table-th title="Procedimento" v-model="ordem" sortby="atendimento_procedimento.procedimento.search"></table-th>
                                        <table-th title="Material" v-model="ordem" sortby="atendimento_procedimento.amostra.search"></table-th>
                                        <table-th title="Solicitante" v-model="ordem" sortby="atendimento_procedimento.atendimento.medico_solicitante.st_nome"></table-th>
                                        <th>Responsáveis</th>
                                        <th>
                                            <grupo-etq-amostras :atp="cassetes_consolidados" color="dark" />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, iix) in lista_filtrada" :key="iix" :class="!item.sel ? 'table-secondary' : ''">
                                        <td>
                                            <input type="checkbox" v-model="item.sel" /> 
                                        </td>
                                        <td>
                                            {{ item.atendimento_procedimento.atendimento.paciente.st_nome }}
                                        </td>
                                        <td>
                                            #{{ item.atendimento_procedimento.id_atendimento }}
                                        </td>
                                        <td>
                                            {{ item.atendimento_procedimento.procedimento.search }}
                                        </td>
                                        <td>
                                            <span v-if="item.atendimento_procedimento.amostra">
                                                {{ item.atendimento_procedimento.amostra.search }}
                                                <template v-if="item.atendimento_procedimento.amostra.js_classes && item.atendimento_procedimento.amostra.js_classes.length == 1">
                                                    <span class="badge badge-success ml-1" v-for="(classe, icx) in item.atendimento_procedimento.amostra.js_classes" :key="icx">
                                                        {{ classe }}
                                                    </span>
                                                </template>
                                            </span>
                                        </td>
                                        <td style="max-width: 100px;">
                                            <div class="text-truncate" v-if="item.atendimento_procedimento.atendimento && item.atendimento_procedimento.atendimento.medico_solicitante">
                                                {{ item.atendimento_procedimento.atendimento.medico_solicitante.st_nome }}
                                            </div>
                                        </td>
                                        <td>
                                            {{ lista_resps(item) }}
                                        </td>
                                        <td>
                                            <grupo-etq-amostras :atp="item.atendimento_procedimento" />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="imprimir_selecionadas()">Imprimir</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import GrupoEtqAmostras from './GrupoEtqAmostras.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import TableTh from '../../shared/table/TableTh.vue';

export default {
    data() {
        return { 
            tipo_etq: "",
            validate: false, 
            lista: null,
            servidor_impressao: "", 
            pesquisa: "", 
            ordem: "", 
        }       
    },

    components: { 
        AzInput,
        AzSubmit, 
        GrupoEtqAmostras, 
        TableTh,
    },

    computed: { 
        is_tipo_lamina: function () { 

            if ( this.tipo_etq && this.tipo_etq.search && this.tipo_etq.search.startsWith('Lâmina') ) { 
                return true;
            }

            return false; 

        },

        lista_filtrada: function () { 
            if ( !this.lista ) { 
                return []; 
            }

            let lista; 

            if ( this.is_tipo_lamina ) { 
                lista = this.lista.filter(item => ( item.atendimento_procedimento && item.atendimento_procedimento.grupo_etq_amostras && item.atendimento_procedimento.grupo_etq_amostras.length ));
            } else { 
                lista = this.lista.filter(item => ( item.atendimento_procedimento && item.atendimento_procedimento.grupo_etq_amostras && item.atendimento_procedimento.grupo_etq_amostras.length ) 
                    && ( !this.tipo_etq || ( item.atendimento_procedimento && item.atendimento_procedimento.grupo_etq_amostras && item.atendimento_procedimento.grupo_etq_amostras.find(ge => ge.tipo_etiqueta && ge.tipo_etiqueta.id_tipo_etiqueta_amostra == this.tipo_etq.id_tipo_etiqueta_amostra) ) )); 
            }

            if ( this.ordem ) { 
                lista = _.orderBy(lista, item => _.get(item, this.ordem.name), this.ordem.direction);
            }

            return lista; 
        },

        selecionados: function () {
            if ( !this.lista_filtrada || !this.lista_filtrada.length )
                return [];

            return this.lista_filtrada.filter(item => item.sel);
        },

        cassetes_consolidados: function () {
            return { 
                grupo_etq_amostras: _.values(
                    this.selecionados.reduce((acc, item) => {
                        if ( item.atendimento_procedimento && item.atendimento_procedimento.grupo_etq_amostras && item.atendimento_procedimento.grupo_etq_amostras.length ) { 
                            item.atendimento_procedimento.grupo_etq_amostras.forEach(ge => {
                                if ( !_.get(acc, _.get(ge, 'tipo_etiqueta.id_tipo_etiqueta_amostra')) ) { 
                                    acc[_.get(ge, 'tipo_etiqueta.id_tipo_etiqueta_amostra')] = _.cloneDeep(ge);
                                } else if ( ge.qt_itens ) { 
                                    acc[_.get(ge, 'tipo_etiqueta.id_tipo_etiqueta_amostra')].qt_itens = acc[_.get(ge, 'tipo_etiqueta.id_tipo_etiqueta_amostra')].qt_itens + ge.qt_itens;
                                }
                            });
                        }
                        return acc;
                    }, {})
                )
            };
        },
    },

    beforeMount() { 
        this.servidor_impressao = this.$util.getCookie('lab_servidor_impressao');
    }, 

    methods: { 
        selecionar_atendimento () { 

            let encontrado = false; 

            this.lista_filtrada.forEach(item => {
                if ( this.pesquisa && this.pesquisa.trim().length ) { 
                    if ( item.atendimento_procedimento && item.atendimento_procedimento.id_atendimento == parseInt(this.pesquisa.trim()) ) { 
                        item.sel = true;
                        encontrado = true; 
                    }
                }
            });

            if ( !encontrado ) { 
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Atenção',
                    detail: 'Atendimento não encontrado na lista: ' + this.pesquisa,
                    life: 3000
                });
            }

            this.pesquisa = null;

            this.$nextTick(() => {
                this.pesquisa = "";
            });

        },

        imprimir_selecionadas () { 
            this.$util.atualizar(this, { 
                service: 'amostras', 
                func: 'imprimir_etiquetas_lote_ap',
                dados: { 
                    id_laudos: this.selecionados.map(item => item.id_laudo), 
                    id_tipo_etiqueta_amostra: this.tipo_etq ? this.tipo_etq.id_tipo_etiqueta_amostra : null,
                    servidor_impressao: this.servidor_impressao,
                    is_tipo_lamina: this.is_tipo_lamina, 
                },
                modal: 'imprimirEtiquetasLoteModal',
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },

        toggle_selecionados() {
            let lista = this.lista_filtrada;

            let opcao = lista.find(ld => !ld.sel);

            lista.forEach(ld => {
                ld.sel = opcao;
            });
        },

        abrir (lista) { 
            let nova_lista = _.cloneDeep(lista);

            if ( !nova_lista ) { 
                nova_lista = [];
            } else { 
                nova_lista = nova_lista.filter(item => item.atendimento_procedimento); 
            }

            this.lista = nova_lista; 

            $('#imprimirEtiquetasLoteModal').modal('show');
        },

        lista_resps (laudo) { 
            let lista = [];

            if ( laudo && laudo.resps && laudo.resps.length ) { 
                lista = laudo.resps.filter(item => item.fl_ativo)
                    .map(item => item.usuario ? item.usuario.st_login : '---' );
            }

            return lista.join(', ');
        },
    }
}
</script>
